import { Icon } from "semantic-ui-react";
import { options, optionsAsLabel, optionsForDate } from "../GanttInfoRenderer";
import { AbstractInfoRenderer } from "./AbstractInfoRenderer";

export class MissionInfoRenderer extends AbstractInfoRenderer {

    static defaultProps = {
        entityName: "Mission2"
    }

    renderContent() {
        const { entity } = this.props;
        const ed = this.getEntityDescriptor();
        return <div className="flex-container-row flex-center flex-wrap gap3">
            {ed.getField("type").renderField(entity, optionsAsLabel)}
            {ed.getField("inactivityType").renderField(entity, options)}
            {ed.getField("startAddress").renderField(entity, options)}
            {ed.getField("startTime").renderField(entity, optionsForDate)}
            <div><Icon name="arrow right" /></div>
            {ed.getField("endAddress").renderField(entity, options)}
            {ed.getField("endTime").renderField(entity, optionsForDate)}
            {ed.getField("humanResource").renderField(entity, optionsAsLabel)}
            {ed.getField("equipmentResource").renderField(entity, optionsAsLabel)}
            {ed.getField("equipmentType").renderField(entity, options)}
            {ed.getField("comment").renderField(entity, options)}
            {ed.getField("status").renderField(entity, optionsAsLabel)}
        </div>
    }
}
